import { Tabs } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import LabBasicInfoContainer from "../BasicInfo/LabBasicInfoContainer";
import { strings } from "../../../helpers";
import MetricsLabContainer from "../Metrics/MetricsLabContainer";
import LabClinicListContainer from "../ClinicList/LabClinicListContainer";

const { TabPane } = Tabs;

export default class LabDetailsTabView extends React.Component {
  render() {
    const { currentPath, details, labId } = this.props;

    const basicInfo = `/lab-details/${labId}/basic-details`;
    const metrics = `/lab-details/${labId}/metrics`;
    const clinics = `/lab-details/${labId}/clinics`;

    return (
      <div className="kc-tabs-view appointment-content-container">
        <Tabs
          type="card"
          className="px-10 line-tabs"
          activeKey={
            currentPath === "basic-details" ? "basic-details" : currentPath
          }
        >
          <TabPane
            key="basic-details"
            tab={<Link to={basicInfo}>{strings.dashboard.details}</Link>}
          >
            <LabBasicInfoContainer details={details} />
          </TabPane>
          <TabPane
            key="metrics"
            tab={<Link to={metrics}>{strings.dashboard.metrics}</Link>}
          >
            <MetricsLabContainer details={details} />
          </TabPane>

          <TabPane
            key="clinics"
            tab={<Link to={clinics}>{strings.dashboard.clinic}</Link>}
          >
            <LabClinicListContainer details={details} />
          </TabPane>
        </Tabs>
      </div>
    );
  }
}
